import type { OwaDate } from '../../schema';
import { GlobalCalendarLocale, GlobalCalendarType } from '../../intl/globalCalendarLocale';
import getIntlYearBase from './base/getIntlYearBase';
import getIntlYearRokuyou from './rokuyou/getIntlYearRokuyou';

export default function getIntlYear(
    date: OwaDate,
    locale: GlobalCalendarLocale,
    format: 'numeric' | '2-digit'
): string {
    switch (locale.calendarType) {
        case GlobalCalendarType.Rokuyou:
            return getIntlYearRokuyou();
        default:
            return getIntlYearBase(date, locale, format);
    }
}
